const ShoppingBasketIcon = ({ className, fill }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.02051 6.74995C6.27459 3.67018 8.85464 1.24994 12 1.24994C15.1453 1.24994 17.7254 3.67018 17.9794 6.74995L19.4645 6.74995C19.9567 6.74989 20.4052 6.74983 20.7642 6.80231C21.1588 6.86001 21.5792 6.998 21.8925 7.3805C22.2023 7.75882 22.2601 8.1971 22.2486 8.59561C22.2381 8.96375 22.1625 9.41432 22.0784 9.91584L20.8588 17.191C20.6661 18.3403 20.5103 19.2701 20.2958 19.9969C20.073 20.7521 19.7631 21.3781 19.2054 21.8613C18.6454 22.3464 17.9864 22.5571 17.2165 22.6557C16.4801 22.75 15.5596 22.75 14.4285 22.75L9.57147 22.75C8.44032 22.75 7.51988 22.75 6.78339 22.6557C6.01359 22.5571 5.35452 22.3464 4.79453 21.8613C4.2368 21.3781 3.92689 20.7521 3.7041 19.9969C3.48966 19.2701 3.33383 18.3404 3.14117 17.191L1.92159 9.91588C1.83746 9.41433 1.76188 8.96376 1.75131 8.59561C1.73986 8.1971 1.79762 7.75882 2.10747 7.3805C2.42074 6.998 2.84113 6.86001 3.23579 6.80231C3.59474 6.74983 4.04319 6.74989 4.53539 6.74995L6.02051 6.74995ZM8.03092 6.74995C8.27697 4.77679 9.96017 3.24994 12 3.24994C14.0398 3.24994 15.723 4.77679 15.969 6.74995L8.03092 6.74995Z"
        fill={fill || "#888888"}
      />
    </svg>
  );
};

export default ShoppingBasketIcon;
